<div class="documents">
  <mat-card class="example-list rowholder">
    <div class="fieldRow head">
      <span class="fieldIcon"></span>
      <span class="fieldName">Name</span>
      <span class="availableOn">Available On</span>
      <span class="fieldType">Field Type</span>
      <!-- <span class="requried">Required</span> -->
      <span class="editField">Edit</span>
      <!-- <span class="delete">Deactivate</span> -->
    </div>
    <div class="example-box" *ngFor="let item of fieldsList">
      <div class="fieldRow">
        <span class="fieldIcon">
          <mat-icon>perm_contact_calendar</mat-icon>
        </span>

        <span class="fieldName">{{ item.fieldName }}</span>

        <span class="availableOn assignedWith">
          <ng-container *ngFor="let i of item.availableOn">

            <mat-icon matTooltipClass="tooltip"
              *ngIf="i.folderName == 'Core' && i.isChecked == true"
              matTooltip="{{i.orgModuleName}}">dns</mat-icon>

            <mat-icon matTooltipClass="tooltip"
              *ngIf="i.folderName == 'Task' && i.isChecked == true"
              matTooltip="{{i.orgModuleName}}">list_alt</mat-icon>

            <mat-icon  matTooltipClass="tooltip"
              *ngIf="i.folderName == 'Company' && i.isChecked == true"
              matTooltip="{{i.orgModuleName}}">group_work</mat-icon>

            <mat-icon matTooltipClass="tooltip"
              *ngIf="i.folderName == 'Contact' && i.isChecked == true"
              matTooltip="{{i.orgModuleName}}">contacts</mat-icon>

            <mat-icon  matTooltipClass="tooltip"
              *ngIf="i.folderName == 'Forms' && i.isChecked == true"
              matTooltip="{{i.orgModuleName}}">description</mat-icon>

          </ng-container>
        </span>

        <span class="fieldType">
          <mat-icon  matTooltipClass="tooltip"
            *ngIf="item.fieldCategoryID == 2" matTooltip="Global">public</mat-icon>

          <mat-icon
            matTooltipClass="tooltip"
            *ngIf="item.fieldCategoryID == 3"
             matTooltip="Custom"
            >account_box</mat-icon >
        </span>

        <!-- <span class="requried">
          <mat-slide-toggle
            color="primary" [checked]="item.isRequired == true"
            (click)="isRequiredfield(item)">
          </mat-slide-toggle>
        </span> -->

        <span class="editField">
          <button
            mat-icon-button
            class="editbtn"
            (click)="editField('editfilledSlide', item)">
            <mat-icon>edit</mat-icon>
          </button>
        </span>

        <!-- <span class="delete">
          <button
            mat-icon-button
            class="trash"
            (click)="deactivateField(item, false)">
            <mat-icon>remove_circle_outline</mat-icon>
          </button>
        </span> -->
      </div>
    </div>
  </mat-card>

  <div class="deativeFields" *ngIf="deactivedrapDropList.length > 0">
    <h3>Inactive Fields ({{ deactivedrapDropList.length }})</h3>

    <mat-card class="example-list rowholder">
      <div class="fieldRow head">     

        <span class="fieldIcon"></span>
        <span class="fieldName">Name</span>
        <span class="availableOn">Available On</span>
        <span class="fieldType">Field Type</span>
        <span class="requried"></span>
        <span class="editField"></span>
        <span class="delete">Activate</span>
      </div>
      <div
        class="example-box fieldRow" *ngFor="let item of deactivedrapDropList">
       
        <span class="fieldIcon">
          <mat-icon>perm_contact_calendar</mat-icon>
        </span>
        <span class="fieldName">{{ item.fieldName }}</span>
        <span class="availableOn assignedWith">
          <ng-container *ngFor="let i of item.availableOn">
            <mat-icon
              matTooltipClass="tooltip"
              *ngIf="i.folderName == 'Core' && i.isChecked == true"
              matTooltip="{{i.folderName}}">dns</mat-icon>
            <mat-icon
              matTooltipClass="tooltip"
              *ngIf="i.folderName == 'Task' && i.isChecked == true"
              matTooltip="{{i.folderName}}">list_alt</mat-icon>
            <mat-icon
              matTooltipClass="tooltip"
              *ngIf="i.folderName == 'Company' && i.isChecked == true"
              matTooltip="{{i.folderName}}">group_work</mat-icon>
            <mat-icon
              matTooltipClass="tooltip"
              *ngIf="i.folderName == 'Contact' && i.isChecked == true"
              matTooltip="{{i.folderName}}">contacts</mat-icon>
            <mat-icon
              matTooltipClass="tooltip"
              *ngIf="i.folderName == 'Forms' && i.isChecked == true"
              matTooltip="{{i.folderName}}">description</mat-icon>
          </ng-container>
        </span>
     
        <span class="fieldType">
          <mat-icon
            matTooltipClass="tooltip"
            *ngIf="item.fieldCategoryTypeID != 3"
            matTooltip="Global">public
          </mat-icon>
          <mat-icon
            matTooltipClass="tooltip"
            *ngIf="item.fieldCategoryTypeID == 3"
            matTooltip="Custom">account_box
          </mat-icon>
        </span>
        <span class="requried"></span>
        <span class="editField"></span>
        <span class="delete">
          <button
            mat-icon-button
            class="trash"
            (click)="deactivateField(item, true)">
            <mat-icon>add_circle_outline</mat-icon>
          </button>
        </span>
      </div>
    </mat-card>

   
  </div>
</div>
